import { useState } from 'react'
import { useToast } from '@/context/ToastContext'
import { Category } from '@/services/m-commerce-api/product/categories'
import { Subcategory } from '@/services/m-commerce-api/product/subcategories'
import { useProductApi } from '@/services/m-commerce-api/product'
import { HomePageContent } from '@/services/cms-api/home-page-content/types'
import { useCmsApi } from '@/services/cms-api'
import { ServiceCategory } from '@/services/cms-api/service-menu/types'

type UseContent = () => {
  getCategoryTree: () => Promise<Category[] | undefined>
  getSubcategories: () => Promise<Subcategory[] | undefined>
  getHomePageContent: () => Promise<HomePageContent | undefined>
  getServiceCategories: () => Promise<ServiceCategory[] | undefined>
}

export const useContent: UseContent = () => {
  const { getCategories, getSubcategories } = useProductApi()
  const { getHomePageContents, getServiceCategories } = useCmsApi()
  const { showError } = useToast()
  const [categoryTrees, setCategoryTrees] = useState<Category[] | undefined>([])
  const [subcategories, setSubcategories] = useState<Subcategory[] | undefined>([])
  const [homePageContent, setHomePageContent] = useState<HomePageContent | undefined>()
  const [serviceCategories, setServiceCategories] = useState<ServiceCategory[] | undefined>()

  return {
    getCategoryTree: async () => {
      const tree = categoryTrees
      if (tree !== undefined && tree.length > 0) {
        return tree
      } else {
        try {
          const res = await getCategories()
          const categories = res.response.productCategoryPopulateDtos
          if (categories.length > 0) {
            setCategoryTrees(categories)
            return categories
          } else {
            showError('Fetch category failed')
          }
        } catch (e) {
          showError('Fetch category failed')
        }
      }
    },
    getSubcategories: async () => {
      if (subcategories !== undefined && subcategories.length > 0) {
        return subcategories
      } else {
        try {
          const res = await getSubcategories()
          const subcategories = res.response.productSubCategoryList
          setSubcategories(subcategories)
          return subcategories
        } catch (e) {
          showError('Fetch category failed')
        }
      }
    },
    getHomePageContent: async () => {
      if (homePageContent !== undefined) {
        return homePageContent
      } else {
        try {
          const res = await getHomePageContents()
          setHomePageContent(res)
          return res
        } catch (e) {
          showError('Fetch home page content failed')
        }
      }
    },
    getServiceCategories: async () => {
      if (serviceCategories !== undefined) {
        return serviceCategories
      } else {
        try {
          const res = await getServiceCategories()
          setServiceCategories(res)
          return res
        } catch (e) {
          showError('Fetch home page content failed')
        }
      }
    }
  }
}
